import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { clearMessage } from 'actions/vessels/orders';

import OpenPosition from './Order/OpenPosition/Component';
import Terms from './Order/Terms';
import DisponentWrapper from './Order/DisponentWrapper';
import Title from '../../../../common/RequestTitle';
import Name from './Order/Name';

class OrderTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTextCargoType: '',
        };

        this.onMessageClose = this.onMessageClose.bind(this);
    }
    
    UNSAFE_componentWillReceiveProps(props) {
        if (props.message) {
            this.setState({
                message: props.message,
                isOpenMessage: true,
            });
        }
    }
    
    onMessageClose() {
        this.setState({
            message: '',
            isOpenMessage: false,
        }, () => {
            this.props.clearMessage(this.props.numberOrderTable);
        });
    }
    
    render() {
        return (
            <div className='sidebar-table'>
                <Title 
                    orderNumber={this.props.numberOrderTable + 1} 
                    text='VESSEL ORDER NUMBER' 
                    warnings={this.props.vesselOrder.warnings} 
                />
                <Name numberOrderTable={this.props.numberOrderTable} />
                <hr />
                <DisponentWrapper numberOrderTable={this.props.numberOrderTable} />
                <hr />
                <OpenPosition numberOrderTable={this.props.numberOrderTable} />
                <hr />
                <Terms numberOrderTable={this.props.numberOrderTable} />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const vesselOrder = state.vesselOrders.items[ownProps.numberOrderTable];

        return {
            numberOrderTable: ownProps.numberOrderTable,
            vesselOrder,
            message: vesselOrder.successMessage.message ? vesselOrder.successMessage.message : '',
        };
    },
    dispatch => bindActionCreators({
        clearMessage,
    }, dispatch),
)(OrderTable);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/OrderTable.jsx